import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, ShieldCheck, Lock, Award, CheckCircle2, Heart, Mail, MapPin } from 'lucide-react';
// Simple SVG icons for social media
const GoogleIcon = () => <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" data-id="element-210">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-211" />
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-212" />
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" data-id="element-213" />
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-214" />
  </svg>;
const FacebookIcon = () => <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" data-id="element-215">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.469h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.469h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-216" />
  </svg>;
const InstagramIcon = () => <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" data-id="element-217">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" data-id="element-218" />
  </svg>;
const YelpIcon = () => <img src="https://cdn.magicpatterns.com/uploads/8mySe4rPguBxgNyW2CPFuM/yelp2.jpg" alt="Yelp" className="w-4 h-4 object-contain" data-id="element-219" />;
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-charcoal text-white/90 pt-12 pb-6" data-id="element-220">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-221">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-10" data-id="element-222">
          <div className="col-span-2 md:col-span-1 space-y-4" data-id="element-223">
            <Link to="/" className="inline-block" data-id="element-224">
              <img src="https://cdn.magicpatterns.com/uploads/fz9bznNPehbKxBqTrq2qaw/EstherMensahLogo.NoBG-V3_(1).webp" alt="Esther Mensah Counselling & Psychotherapy" className="h-[66px] w-auto brightness-0 invert opacity-90" data-id="element-225" />
            </Link>
            <p className="text-white/60 text-sm leading-relaxed max-w-xs font-medium" data-id="element-226">
              Providing compassionate, culturally sensitive therapy in a safe
              and supportive space.
            </p>
            <div className="flex gap-3 pt-2" data-id="element-227">
              <a href="https://share.google/icvD2yMNf6yhvy7Im" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors text-white hover:text-gold" aria-label="Google Reviews" data-id="element-228">
                <GoogleIcon data-id="element-229" />
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors text-white hover:text-gold" aria-label="Facebook" data-id="element-230">
                <FacebookIcon data-id="element-231" />
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors text-white hover:text-gold" aria-label="Instagram" data-id="element-232">
                <InstagramIcon data-id="element-233" />
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors text-white hover:text-gold" aria-label="Yelp" data-id="element-234">
                <YelpIcon data-id="element-235" />
              </a>
            </div>
          </div>

          <div data-id="element-236">
            <h3 className="font-heading font-bold text-sm text-white mb-4 uppercase tracking-wide" data-id="element-237">
              Quick Links
            </h3>
            <ul className="space-y-2" data-id="element-238">
              <li data-id="element-239">
                <Link to="/about" className="text-white/60 hover:text-white transition-colors text-sm" data-id="element-240">
                  About
                </Link>
              </li>
              <li data-id="element-241">
                <Link to="/services" className="text-white/60 hover:text-white transition-colors text-sm" data-id="element-242">
                  Services
                </Link>
              </li>
              <li data-id="element-243">
                <Link to="/fees" className="text-white/60 hover:text-white transition-colors text-sm" data-id="element-244">
                  Fees & Policies
                </Link>
              </li>
              <li data-id="element-245">
                <Link to="/blog" className="text-white/60 hover:text-white transition-colors text-sm" data-id="element-246">
                  Blog
                </Link>
              </li>
              <li data-id="element-247">
                <Link to="/contact" className="text-white/60 hover:text-white transition-colors text-sm" data-id="element-248">
                  Contact
                </Link>
              </li>
              <li data-id="element-249">
                <a href="https://esthermensah.janeapp.com/" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors text-sm" data-id="element-250">
                  Book Appointment
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-251">
            <h3 className="font-heading font-bold text-sm text-white mb-4 uppercase tracking-wide" data-id="element-252">
              Services
            </h3>
            <ul className="space-y-2" data-id="element-253">
              <li data-id="element-254">
                <Link to="/services/individual" className="text-white/60 hover:text-white transition-colors text-sm" data-id="element-255">
                  Individual Counselling
                </Link>
              </li>
              <li data-id="element-256">
                <Link to="/services/couples" className="text-white/60 hover:text-white transition-colors text-sm" data-id="element-257">
                  Couples Therapy
                </Link>
              </li>
              <li data-id="element-258">
                <Link to="/services/family" className="text-white/60 hover:text-white transition-colors text-sm" data-id="element-259">
                  Family Therapy
                </Link>
              </li>
              <li data-id="element-260">
                <Link to="/services/trauma" className="text-white/60 hover:text-white transition-colors text-sm" data-id="element-261">
                  Trauma Therapy
                </Link>
              </li>
              <li data-id="element-262">
                <Link to="/services/emdr" className="text-white/60 hover:text-white transition-colors text-sm" data-id="element-263">
                  EMDR Therapy
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-264">
            <h3 className="font-heading font-bold text-sm text-white mb-4 uppercase tracking-wide" data-id="element-265">
              Contact Esther
            </h3>
            <div className="space-y-4" data-id="element-266">
              <a href="tel:5489000692" className="flex items-center gap-3 text-white/80 hover:text-gold transition-colors text-sm font-medium" data-id="element-267">
                <div className="w-8 h-8 rounded-lg bg-white/5 flex items-center justify-center flex-shrink-0" data-id="element-268">
                  <Phone size={14} data-id="element-269" />
                </div>
                548-900-0692
              </a>
              <a href="mailto:esther@esthermensahcounselling.com" className="flex items-center gap-3 text-white/80 hover:text-gold transition-colors text-sm font-medium break-all" data-id="element-270">
                <div className="w-8 h-8 rounded-lg bg-white/5 flex items-center justify-center flex-shrink-0" data-id="element-271">
                  <Mail size={14} data-id="element-272" />
                </div>
                esther@esthermensahcounselling.com
              </a>
              <div className="flex items-start gap-3 text-white/80 text-sm font-medium" data-id="element-273">
                <div className="w-8 h-8 rounded-lg bg-white/5 flex items-center justify-center flex-shrink-0" data-id="element-274">
                  <MapPin size={14} data-id="element-275" />
                </div>
                <span data-id="element-276">
                  370 Queens Avenue
                  <br data-id="element-277" />
                  London, Ontario
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Google Review CTA */}
        <div className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6 mb-10" data-id="element-278">
          <div data-id="element-279">
            <h3 className="font-heading font-bold text-xl text-white mb-2" data-id="element-280">
              Love your experience? Leave us a review!
            </h3>
            <p className="text-white/70 text-sm font-medium" data-id="element-281">
              Your feedback helps others find the support they need.
            </p>
          </div>
          <a href="https://share.google/icvD2yMNf6yhvy7Im" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-gold hover:bg-gold/90 text-white px-8 py-3.5 rounded-full font-bold text-sm transition-all shadow-lg whitespace-nowrap" data-id="element-282">
            <GoogleIcon data-id="element-283" />
            <span className="ml-2" data-id="element-284">Leave a Google Review</span>
          </a>
        </div>

        <div className="py-5 border-t border-b border-white/10 mb-5" data-id="element-285">
          <div className="flex flex-wrap items-center justify-center gap-5 md:gap-8" data-id="element-286">
            <div className="flex items-center gap-2.5 text-white/70" data-id="element-287">
              <ShieldCheck size={22} className="text-olive" data-id="element-288" />
              <span className="text-sm font-bold uppercase tracking-wide" data-id="element-289">
                HIPAA Compliant
              </span>
            </div>
            <div className="flex items-center gap-2.5 text-white/70" data-id="element-290">
              <Lock size={22} className="text-olive" data-id="element-291" />
              <span className="text-sm font-bold uppercase tracking-wide" data-id="element-292">
                SSL Encrypted
              </span>
            </div>
            <div className="flex items-center gap-2.5 text-white/70" data-id="element-293">
              <Award size={22} className="text-olive" data-id="element-294" />
              <span className="text-sm font-bold uppercase tracking-wide" data-id="element-295">
                Licensed & Insured
              </span>
            </div>
            <div className="flex items-center gap-2.5 text-white/70" data-id="element-296">
              <Heart size={22} className="text-olive" data-id="element-297" />
              <span className="text-sm font-bold uppercase tracking-wide" data-id="element-298">
                Emotionally Focused Therapy (EFT)
              </span>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-white/50 font-medium" data-id="element-299">
          <p data-id="element-300">
            &copy; {currentYear} Esther Mensah Counselling. All rights reserved.
          </p>
          <div className="flex gap-4" data-id="element-301">
            <a href="#" className="hover:text-white transition-colors" data-id="element-302">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-303">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}